export interface PartnerFormGridProps {
    className?: string;
    style?: React.CSSProperties;
}

export enum PartnerFormGridNames {
    NAME = "name",
    DESCRIPTION = "description",
    LINK = "link",
    LOCATION = "location",
    BANNER = "banner",
    LOGO = "logo",
    SCHEDULED_REDEEM = "scheduledRedeem.frequency"
}
